import React from 'react';
import { includes, isEmpty } from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Container } from './styles/Container.styled';
import { Row } from './styles/Row.styled';
import { ColumnSixMd } from './styles/Column.styled';
import MultilineTitle from './multilineTitle';
import {
  FeaturedBlock,
  FeaturedCard,
  FeaturedImage,
  FeaturedText,
} from './styles/FeaturedBlock.styled';
import { Button } from './styles/Button.styled';
import { DWTCContext } from '../utils/context';

export default function TwoColumnCTA({ data, id, dir }) {
  const { cssClass } = React.useContext(DWTCContext);
  const [multiColor, setMultiColor] = React.useState(false);
  const [buttonTheme, setButtonTheme] = React.useState('');
  const [isAbout, setIsAbout] = React.useState(false);
  const [isVirtual, setIsVirtual] = React.useState(false);
  const lang = dir === 'ltr' ? 'en' : 'ar';
  const isBrowser = typeof window !== 'undefined';

  React.useEffect(() => {
    if (isBrowser) {
      setIsAbout(window.location.pathname === `/${lang}/about/`);
      setIsVirtual(window.location.pathname === `/${lang}/free-zone-virtual-assets/`);
    }
  }, [isBrowser, lang]);

  React.useEffect(() => {
    if (includes(cssClass, 'events', 'isHome')) setMultiColor(true);
    else if (includes(cssClass, 'free-zone')) setButtonTheme('red');
    else if (includes(cssClass, 'real-estate')) setButtonTheme('green');
    else setButtonTheme('secondary');
  }, []);

  const btnColor1 = data.ctas[0].content.backgroundColor;
  const btnColor2 = data.ctas[1].content.backgroundColor;

  let btnFirst = 'red';
  let btnSecond = 'green';

  if (!isEmpty(btnColor1)) {
    if (btnColor1 === '1b7bdd') {
      btnFirst = 'secondary';
    } else if (btnColor1 === 'ce445b') {
      btnFirst = 'red';
    } else {
      btnFirst = 'green';
    }
  } else {
    btnFirst = 'red';
  }

  if (!isEmpty(btnColor2)) {
    if (btnColor2 === '1b7bdd') {
      btnSecond = 'secondary';
    } else if (btnColor2 === 'ce445b') {
      btnSecond = 'red';
    } else {
      btnSecond = 'green';
    }
  } else {
    btnSecond = 'green';
  }

  return (
    <FeaturedBlock id={id} dir={dir}>
      <Container>
        <Row>
          <ColumnSixMd>
            <FeaturedCard
              className={`${isAbout ? 'is-about' : ''}${isVirtual ? 'is-virtual' : ''}`}
            >
              {isEmpty(data.ctas[0].content.backgroundImage) || (
                <FeaturedImage>
                  <LazyLoadImage
                    src={data.ctas[0].content.backgroundImage.url}
                    width="100%"
                    effect="blur"
                    placeholderSrc={`${data.ctas[0].content.backgroundImage.url}?width=50&quality=50`}
                  />
                </FeaturedImage>
              )}
              <FeaturedText dir={dir} className="ctatext">
                <MultilineTitle
                  title={data.ctas[0].content.title}
                  description={data.ctas[0].content.description}
                  link={null}
                  dir={dir}
                />
                {isEmpty(data.ctas[0].content.links) ||
                  data.ctas[0].content.links.map(({ url, target, name }, index) => (
                    <div key={index}>
                      <Button
                        stylevariant={multiColor ? btnFirst : buttonTheme}
                        to={url}
                        target={target}
                        rel=""
                        dir={dir}
                      >
                        {name}
                      </Button>
                    </div>
                  ))}
              </FeaturedText>
            </FeaturedCard>
          </ColumnSixMd>
          <ColumnSixMd>
            <FeaturedCard
              className={`${isAbout ? 'is-about' : ''}${isVirtual ? 'is-virtual' : ''}`}
            >
              {isEmpty(data.ctas[1].content.backgroundImage) || (
                <FeaturedImage>
                  <LazyLoadImage
                    src={data.ctas[1].content.backgroundImage.url}
                    width="100%"
                    effect="blur"
                    placeholderSrc={`${data.ctas[1].content.backgroundImage.url}?width=50&quality=50`}
                  />
                </FeaturedImage>
              )}
              <FeaturedText dir={dir} className="ctatext">
                <MultilineTitle
                  title={data.ctas[1].content.title}
                  description={data.ctas[1].content.description}
                  link={null}
                />
                {isEmpty(data.ctas[1].content.links) ||
                  data.ctas[1].content.links.map(({ url, target, name }, index) => (
                    <div key={index}>
                      <Button
                        stylevariant={multiColor ? btnSecond : buttonTheme}
                        to={url}
                        target={target}
                        rel=""
                        dir={dir}
                      >
                        {name}
                      </Button>
                    </div>
                  ))}
              </FeaturedText>
            </FeaturedCard>
          </ColumnSixMd>
        </Row>
      </Container>
    </FeaturedBlock>
  );
}
